import { render, staticRenderFns } from "./FixedAssetStatement.vue?vue&type=template&id=6b280fb5&scoped=true"
import script from "./FixedAssetStatement.vue?vue&type=script&lang=js"
export * from "./FixedAssetStatement.vue?vue&type=script&lang=js"
import style0 from "./FixedAssetStatement.vue?vue&type=style&index=0&id=6b280fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b280fb5",
  null
  
)

export default component.exports